// Auto-generated by webpack.mix.js — do not edit
// Aggregates all PHP translation files for locale en_US
const req = require.context('../../../../../lang/en_US', false, /\.php$/);
const messages = {};
req.keys().forEach(key => {
  const name = key.replace('./','').replace('.php','');
  messages['en_US.' + name] = req(key);
});
// If Lang is available in window, initialize or update it
if (typeof window !== 'undefined' && window.Lang) {
  if (window.lang && typeof window.lang.setMessages === 'function') {
    window.lang.setMessages(messages);
  } else {
    window.lang = new window.Lang({messages});
  }
}
export default messages;
